import { useNavigate } from 'react-router-dom'

import { SendTaskReminderModal } from '../../Process/components/DataTable/components'

const SendTaskRemindersModalPage = () => {
  const navigate = useNavigate()

  const onClose = () => {
    navigate(-1)
  }

  return <SendTaskReminderModal onClose={onClose} onSuccess={onClose} />
}

export default SendTaskRemindersModalPage
